/** @typedef {import('./create').RichTextValue} RichTextValue */

/**
 * Check if the selection of a Rich Text value is collapsed or not. Collapsed
 * means that no characters are selected, but there is a caret present. If there
 * is no selection, `undefined` will be returned. This is similar to
 * `window.getSelection().isCollapsed()`.
 *
 * @param {RichTextValue} value The rich text value to check.
 *
 * @return {boolean|undefined} True if the selection is collapsed, false if not,
 *                             undefined if there is no selection.
 */
export function isCollapsed(_ref) {
  let {
    start,
    end
  } = _ref;

  if (start === undefined || end === undefined) {
    return;
  }

  return start === end;
}
//# sourceMappingURL=is-collapsed.js.map